
import { Skeleton } from "@/components/ui/skeleton";
import { Navbar } from '@/components/homepage/Navbar';
import Footer from '@/components/homepage/Footer';

const AuthSkeleton = () => {
  return (
    <>
      <Navbar />
      <div className="relative min-h-screen overflow-x-hidden bg-gradient-to-br from-gray-900 via-blue-950 to-gray-900">
        {/* Background elements */}
        <div className="absolute inset-0 bg-black/30 z-0"></div>
        <div className="absolute top-0 right-1/3 w-80 h-80 rounded-full bg-indigo-500/5 blur-3xl"></div>
        <div className="absolute bottom-0 left-1/3 w-64 h-64 rounded-full bg-purple-500/10 blur-3xl"></div>
        
        <div className="relative z-10 container mx-auto px-4 pt-28 pb-16">
          {/* Title and subtitle skeleton */}
          <div className="text-center mb-8">
            <div className="flex justify-center mb-6">
              <Skeleton className="h-16 w-32 bg-white/10" />
            </div>
            <Skeleton className="h-12 w-80 mx-auto mb-2 bg-white/10" />
            <Skeleton className="h-8 w-96 mx-auto bg-white/10" />
          </div>

          <div className="max-w-lg mx-auto glassmorphism-dark p-8 rounded-xl">
            <div className="space-y-4">
              <div className="space-y-2">
                <Skeleton className="h-4 w-16 bg-white/10" />
                <Skeleton className="h-10 w-full bg-white/10" />
              </div>
              <div className="space-y-2">
                <Skeleton className="h-4 w-20 bg-white/10" />
                <Skeleton className="h-10 w-full bg-white/10" />
              </div>
              <Skeleton className="h-10 w-full bg-white/10" />
              <Skeleton className="h-4 w-32 mx-auto bg-white/10" />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AuthSkeleton;
